import React, { useState, useEffect } from 'react';

import { Container, LabelInputContainer, Label, Input, HelperContainer, SuggestedOptionsContainer, SelectOption, BottomLineBlack, ErrorText, BottomLineGrey, InputSelect, InputSelectEditable } from "./style";
import { THEME_COLORS } from '../../styles/theme';
import { SelectArrow, SelectArrowContainer } from './SelectArrow';
import { VALIDATORS_TYPE, INPUT_TYPES } from '../../utils/constants';
import { fieldValidator } from '../../utils/fieldValidator';

const TextInputC = ({
    value, labelText = "Label",
    HelperComponent = null,
    error = "",
    options = [],
    editable = true,
    type = INPUT_TYPES.text,
    placeholder = undefined,
    validator = VALIDATORS_TYPE.noNumbers,
    hasLeftPadding = false,
    onBlurValidator = () => { },
    onSelectOption = () => { },
    onValueChange = () => { },
    onFocus = () => { },
    optionsExtractText = () => { },
    optionsExtractKey = () => { }
}, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const [randomFieldName, setFieldName] = useState('name');
    const hasValue = value && value.length > 0;
    const hasError = error && error.length > 0;

    const setRandomFieldName = () => {
        const randomFieldName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        setFieldName(randomFieldName);
    }

    useEffect(() => {
        setRandomFieldName();
    }, []);

    let labelColor = THEME_COLORS.darkGray;
    if (hasError) {
        labelColor = THEME_COLORS.red;
    } else if (isFocused) {
        labelColor = THEME_COLORS.darkGray;
    }

    const isLabelFloating =  type ===  INPUT_TYPES.select ? hasValue : hasValue || isFocused;
    const isHelperComponentVisible = !isLabelFloating || !hasValue;
    const isSelect = type === INPUT_TYPES.select || type === INPUT_TYPES.selectEditable;

    let component = null;
    if (isSelect) {
        component = <InputSelectEditable
            onFocus={() => {
                onFocus();
                setIsFocused(true);
            }}
            onBlur={() => {
                setIsFocused(false);
                onBlurValidator();
            }}
            onClick={() => setIsFocused(true)}
            value={value}
            onChange={e => {
                if (type === INPUT_TYPES.selectEditable) {
                    onValueChange(e.target.value);
                }
                setIsFocused(true);
            }}
            isTextEditable={type === INPUT_TYPES.selectEditable}
            ref={ref}
            autoComplete={randomFieldName}
        />
    } else {
        component = <Input
            hasLeftPadding={hasLeftPadding}
            disabled={!editable}
            onFocus={() => {
                setRandomFieldName();
                onFocus();
                setIsFocused(true);
            }}
            onBlur={() => {
                setIsFocused(false);
                onBlurValidator();
            }}
            value={value}
            onChange={e => onValueChange(fieldValidator(e.target.value, validator))}
            color={hasError ? THEME_COLORS.red : THEME_COLORS.darkBlue}
            ref={ref}
            placeholder={isFocused && placeholder ? placeholder : ""}
            autoComplete={randomFieldName}
        />
    }

    return (
        <Container>
            <LabelInputContainer>
                <Label
                    isFloating={isLabelFloating}
                    labelColor={labelColor}
                    hasLeftPadding={hasLeftPadding}
                >
                    {labelText}
                </Label>

                <HelperContainer isVisible={isHelperComponentVisible} isSelect={isSelect}>
                    {HelperComponent}
                </HelperContainer>
                {isSelect && <SelectArrowContainer onClick={() => setIsFocused(true)}>
                    <SelectArrow />
                </SelectArrowContainer>}
                {options && options.length > 0 && isFocused &&
                    <SuggestedOptionsContainer>
                        {options
                            .map(option => <SelectOption
                                onClick={() => {
                                    onSelectOption(option);
                                    setIsFocused(false);
                                }}
                                onMouseDown={event => event.preventDefault()}
                                key={optionsExtractKey(option)}
                            >{optionsExtractText(option)}</SelectOption>)}
                    </SuggestedOptionsContainer>
                }
                {component}
            </LabelInputContainer>
            <div>
                <BottomLineGrey />
                <BottomLineBlack isFocused={isFocused || hasValue || hasError} hasError={hasError} />
            </div>
            {hasError && <ErrorText>{error}</ErrorText>}
        </Container>
    );
}

export const TextInput = React.forwardRef(TextInputC);